import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { SecondaryLink } from 'components/Link'
import { colors } from 'utils/colors'
import { BREAKPOINTS, pxToRem } from 'utils/styled'

export const SProfileSidebar = styled.div`
  flex-shrink: 0;
  background: ${colors.gray[200]};
  padding: 0 var(--p-spacing) 0;

  display: flex;
  flex-direction: column;

  position: relative;

  max-width: ${pxToRem(333)}rem;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    width: 20px;
    background: linear-gradient(to left, rgba(98, 131, 147, 0.1), rgba(98, 131, 147, 0));
  }

  @media ${BREAKPOINTS.MD.max} {
    display: none;
  }
`

export const SLogoAnchor = styled.a`
  display: flex;
  align-items: center;
  height: var(--h-header);
  min-height: 60px;
  margin-bottom: 1.875rem;
`

export const ProfileSidebarLink = styled(SecondaryLink)<{
  active?: boolean
}>`
  border-bottom: 2px solid transparent;
  display: flex;
  align-items: center;
  width: 100%;

  &[disabled] {
    opacity: 0.4;
    pointer-events: none;

    &:hover {
      text-decoration: none;
    }
  }

  ${({ active = false }) => {
    if (active) {
      return css`
        font-weight: bold;

        & > span:last-child {
          color: ${colors.black};
        }
        &:hover {
          text-decoration: none;
        }
      `
    }
    return {}
  }}
`

export const SLogoDivider = styled.div`
  height: 1rem;
  width: 1px;
  background-color: #e5f2f8;
`

export const SAolLogoWrapper = styled.div`
  svg {
    width: 1.875rem;
  }
`
